module.exports = __webpack_public_path__ + "static/media/icononomegusto.e761e867.svg";